import { useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { fetchArenaCategoryData } from "../../utils/api";

// Component to display arena categories as colored buttons
const CategoryView = ({ categories, setCategories, setTab, setLoading }) => {
	useEffect(() => {
		// Fetch arena category data from the API on component mount
		const fetchData = async () => {
			try {
				setLoading(true); // Set loading to true before fetching data

				const data = await fetchArenaCategoryData();
				if (data) {
					setCategories(data.categories);
					setTab(data.tab);
				}
			} catch (error) {
				// Handle error
			} finally {
				setLoading(false); // Set loading to false after fetching (success or failure)
			}
		};

		fetchData();
	}, []);

	return (
		<div className={"container-fluid text-center"}>
			<Row>
				{/* Mapping through arena category data to create colored buttons */}
				{categories.map((category) => {
					// Style for the colored buttons based on category color
					const buttonStyle = {
						backgroundColor: category.color,
						color: category.text_color,
						border: "none",
						padding: "10px",
					};

					return (
						<Col
							lg="2"
							variant=""
							key={"cat_button_" + category.id}
							style={buttonStyle}
							className={
								"d-flex align-items-center justify-content-center"
							}
						>
							{/* Displaying category name */}
							{category.name} - {category.details}
						</Col>
					);
				})}
			</Row>
		</div>
	);
};

export default CategoryView;
